// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAQljmpv_dbO8fODOx-mxtGO8LXeqA8w_Q",
  authDomain: "compeat-int.firebaseapp.com",
  projectId: "compeat-int",
  storageBucket: "compeat-int.appspot.com",
  messagingSenderId: "917664928560",
  appId: "1:917664928560:web:c74a9f9f58af4a20642ef5",
  measurementId: "G-GMH1N4DMZK"
};

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const firebaseApp = initializeApp(firebaseConfig)